module.exports = __webpack_public_path__ + "08_mustache_silver.c81da534.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/08_mustache_silver.png
// module id = 9Jv0
// module chunks = 0